{
  "ceoDateOccupations": [
    "CEO",
    "Chairman-CEO",
    "Chairman - Co-CEO",
    "Chairman-Interim CEO",
    "Co-CEO",
    "Co-Chairman - CEO",
    "Co-Chairman - Co-CEO",
    "Interim CEO",
    "Interim Chairman-CEO"
  ]
}
